// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dagG","colBig":"styles_colBig__2Hs7J","colSmall":"styles_colSmall__1IdHI","shopifyNameWrapper":"styles_shopifyNameWrapper__1-Il9"};